import React from "react";
import { LogOut } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { clearAuth, getAuth } from "../lib/auth";

export default function TopBar({ subtitle, right }) {
  const nav = useNavigate();
  const auth = getAuth();

  const logout = () => {
    clearAuth();
    nav("/login", { replace: true });
  };

  return (
    <header className="border-b border-border bg-background/85 backdrop-blur-md sticky top-0 z-40 safe-pt">
      <div className="px-4 sm:px-6 lg:px-10 py-2.5 sm:py-3 flex items-center justify-between">
        <div className="flex items-center gap-3 min-w-0">
          <div className="relative shrink-0">
            <img
              src="/brand/logo-transparent.png"
              alt="Maanas Fintech"
              className="h-9 sm:h-11 w-auto object-contain"
            />
          </div>
          <div className="min-w-0">
            <div className="text-[11px] sm:text-[13px] tracking-[0.22em] font-bold uppercase text-foreground font-display truncate">
              Maanas <span className="text-lime">Fintech</span>
            </div>
            {subtitle ? (
              <div className="text-[9px] sm:text-[10px] text-muted-foreground tracking-[0.28em] uppercase truncate font-mono">
                {subtitle}
              </div>
            ) : null}
          </div>
        </div>
        <div className="flex items-center gap-2 sm:gap-3 shrink-0">
          {right}
          <div className="text-right hidden md:block">
            <div className="text-[10px] uppercase tracking-[0.2em] text-muted-foreground font-mono">Signed in</div>
            <div className="text-sm font-semibold">{auth?.name}</div>
          </div>
          <button
            data-testid="logout-btn"
            onClick={logout}
            className="border border-border hover:border-destructive hover:text-destructive px-2.5 sm:px-3 py-1.5 sm:py-2 text-[10px] sm:text-xs font-semibold uppercase tracking-[0.18em] rounded-md flex items-center gap-1.5"
          >
            <LogOut className="h-3.5 w-3.5" strokeWidth={1.5} />
            <span className="hidden sm:inline">Sign out</span>
          </button>
        </div>
      </div>
    </header>
  );
}
